module.exports = __webpack_public_path__ + "img/border.92c2086f.png";